/* @noflow FIXME after Flow 56 merged */
import * as React from 'react';
import Group from 'entities/Group';
import { connect } from 'react-redux';
import ScrollLoadZone from 'components/ScrollLoadZone';
import GroupMembership from 'entities/GroupMembership';
import PeopleTableRow from 'components/PeopleTableRow';

import './styles/PeopleTableBody.scss';

type Props = {
  group: Group,
  error?: Error,
  allLoaded: boolean,
  loadNextPage: () => Promise<any>,
  memberships: GroupMembership[],
  adminConsoleAccess: ?boolean,
  memberSummaries: classMemberSummaryFragment[],
  canViewFamily: boolean,
};

class PeopleTableBody extends React.Component<Props> {
  handleBottomReached = () => {
    return this.props.loadNextPage();
  };

  getFamilySummary = (member: GroupMembership) => {
    if (!this.props.canViewFamily) {
      return null;
    }

    const { id } = member.getUser();
    const memberSummary = this.props.memberSummaries.filter(summary => summary.user.id === id)[0];
    return memberSummary ? memberSummary.family_summary : null;
  };

  render() {
    const { canViewFamily, error, allLoaded, memberships, adminConsoleAccess } = this.props;

    const rows = memberships.map(m => (
      <PeopleTableRow
        canViewFamily={canViewFamily}
        familySummary={this.getFamilySummary(m)}
        key={m.id}
        membership={m}
        adminConsoleAccess={adminConsoleAccess}
        group={this.props.group}
      />
    ));

    if (error) {
      rows.push(
        <tr key="people_table_error">
          <td className="PeopleTableBody-error" colSpan={99}>
            {error.message}
          </td>
        </tr>
      );
    }

    return (
      <tbody className="PeopleTableBody">
        {rows}
        {!error &&
          !allLoaded && (
            <tr>
              <td colSpan={99} className="PeopleTableBody-loading">
                <ScrollLoadZone onZoneActivated={this.handleBottomReached} threshold={500} />
              </td>
            </tr>
          )}
      </tbody>
    );
  }
}

function mapStateToProps(state: any, props: Props) {
  return {
    hasSelection: state.peopleTables.get(props.group.id).selectedMemberships.size > 0,
  };
}

export { PeopleTableBody };
export default connect(
  mapStateToProps,
  undefined
)(PeopleTableBody);
